/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { EmbedBuilderFieldDisplay } from "./display";
import { EmbedBuilderFieldEdit } from "./edit";

const EmbedBuilderField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <EmbedBuilderFieldDisplay />,
        editComponent: <EmbedBuilderFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
EmbedBuilderField.displayName = "EmbedBuilderField";
export { EmbedBuilderField };
